import { useTranslation } from 'react-i18next';
import { QBox, QHeading, QStack, QText } from '@qualio/ui-components';
import { Approver, Form, FormStatusEnum, Group, QualityEvent, User } from '../../../../types';
import { UserWithComment } from '../UserWithComments/UserWithComments';
import { ManageApprovalUsersButton } from './ManageApprovalUsersButton/ManageApprovalUsersButton';
import { Reviewers, QualityApprovers, OtherApprovers } from '../../../../displayStrings';

type ManageApprovalUsersProps = {
  stepId: number;
  companyId: number;
  groups: Group[];
  users: User[];
  event: QualityEvent;
  form: Form;
  approvalUsers: Approver[];
  allCurrentApprovers?: Approver[];
  qualityApprovalRequired?: boolean;
  approverType: 'quality' | 'other' | 'reviewer' | 'mergedApprovers';
};

export const ManageApprovalUsers = ({
  stepId,
  companyId,
  groups,
  users,
  event,
  form,
  approvalUsers,
  allCurrentApprovers,
  qualityApprovalRequired,
  approverType,
}: ManageApprovalUsersProps) => {
  const { t } = useTranslation();
  const titleMap = {
    reviewer: Reviewers,
    quality: QualityApprovers,
    other: OtherApprovers,
    mergedApprovers: t('common.labels.approvers'),
  };
  const approversTypeMap = {
    reviewer: 'reviewers',
    quality: 'quality-approvers',
    other: 'other-approvers',
    mergedApprovers: 'approvers',
  };

  return (
    <QBox data-cy={`event-form-${approversTypeMap[approverType]}`}>
      <QStack
        isInline
        justifyContent="space-between"
        alignItems="center"
        data-cy={`event-form-manage-${approversTypeMap[approverType]}`}
      >
        <QHeading fontSize="md">{titleMap[approverType]}</QHeading>
        <ManageApprovalUsersButton
          stepId={stepId}
          companyId={companyId}
          groups={groups}
          users={users}
          currentApprovalUsers={approvalUsers}
          allCurrentApprovers={allCurrentApprovers}
          qualityApprovalRequired={qualityApprovalRequired}
          qualityEvent={event}
          form={form}
          approverType={approverType}
        />
      </QStack>
      <QStack spacing={3} mt={3}>
        {approvalUsers.length > 0 ? (
          approvalUsers.map((approvalUser) => {
            return (
              <UserWithComment
                key={approvalUser.full_name}
                approver={approvalUser}
                approvalType={approverType === 'reviewer' ? 'review' : 'approve'}
                formStatus={form.status as FormStatusEnum}
              />
            );
          })
        ) : (
          <QText>{t('common.labels.none')}</QText>
        )}
      </QStack>
    </QBox>
  );
};
